/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef } from 'react';
import ApexCharts, { ApexOptions } from 'apexcharts';
import { getCSSVariableValue } from 'src/_metronic/assets/ts/_utils';
import './styles.css';

type Props = {
  chartColor: string;
  chartHeight: string;
  chartData: any;
};

const Donut: React.FC<Props> = ({ chartColor, chartHeight, chartData }) => {
  const chartRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!chartRef.current && !chartData) {
      return;
    }

    const chart = new ApexCharts(chartRef.current, chartOptions(chartColor, chartHeight, chartData));
    if (chart) {
      chart.render();
    }

    return () => {
      if (chart) {
        chart.destroy();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chartRef, chartData]);

  return <div ref={chartRef} id="donut-chart" className="mixed-widget-4-chart row donut"></div>;
};

const chartOptions = (chartColor: string, chartHeight: string, chartData: any): ApexOptions => {
  return {
    series: [chartData?.admin ?? 0, chartData?.customer ?? 0, chartData?.vendor ?? 0, 0],
    chart: {
      width: 700,
      type: 'donut',
    },
    colors: ['#008ffb', '#00e396', '#feb019', '#f1416c'],
    labels: ["İdefix'in İptalleri", 'Müşterinin İptalleri', 'Satıcı’nın İptalleri', 'Tüm İptaller'],
    plotOptions: {
      pie: {
        startAngle: -90,
        endAngle: 270,
      },
    },
    dataLabels: {
      enabled: true,
      textAnchor: 'middle',
      style: {
        colors: ['#ececec'],
        fontSize: '10px',
      },
      offsetX: 0,
      dropShadow: {
        enabled: true,
      },
    },
    legend: {
      show: true,
      position: 'right',
      offsetY: 0,
      fontSize: '14px',
      labels: {
        colors: ['rgb(55, 61, 63)'],
      },

      formatter: (val, opts) => {
        const fakeData = ["İdefix'in İptalleri", 'Müşterinin İptalleri', 'Satıcı’nın İptalleri', 'Tüm İptaller'];
        const fakeValues = [chartData?.admin ?? 0, chartData?.customer ?? 0, chartData?.vendor ?? 0, chartData?.total ?? 0];
        return `<div class="mx-2 d-flex flex-lg-column flex-md-row flex-sm-row flex-xs-row justify-content-between"><div>${
          fakeData[opts.seriesIndex]
        }</div><div class="fw-bolder mx-lg-0 mx-3">${fakeValues[opts.seriesIndex]}</div></div>`;
      },
    },
    responsive: [
      {
        breakpoint: 1616,
        options: {
          chart: {
            width: '100%',
          },

          legend: {
            offsetY: -25,
            position: 'right',
          },
        },
      },
      {
        breakpoint: 1410,
        options: {
          chart: {
            width: '100%',
          },

          legend: {
            position: 'right',
            height: '100%',
            offsetY: 0,
            itemMargin: {
              vertical: 10,
              horizontal: 10,
            },
          },
        },
      },
      {
        breakpoint: 1300,
        options: {
          chart: {
            width: '100%',
          },

          legend: {
            position: 'right',
            height: '100%',
            offsetY: 0,

            itemMargin: {
              vertical: 10,
              horizontal: 10,
            },
          },
        },
      },
      {
        breakpoint: 1220,
        options: {
          chart: {
            width: '100%',
          },
          legend: {
            position: 'right',
            height: '100%',
            offsetY: 0,

            itemMargin: {
              vertical: 10,
              horizontal: 10,
            },
          },
        },
      },
      {
        breakpoint: 1010,
        options: {
          chart: {
            width: '100%',
          },
          legend: {
            position: 'bottom',
            height: '100%',
            offsetY: 0,

            itemMargin: {
              vertical: 10,
              horizontal: 10,
            },
          },
        },
      },
      {
        breakpoint: 850,
        options: {
          chart: {
            width: '100%',
          },
          legend: {
            position: 'bottom',
            height: '100%',
            offsetY: 0,

            itemMargin: {
              vertical: 3,
              horizontal: 3,
            },
          },
        },
      },
      {
        breakpoint: 768,
        options: {
          chart: {
            width: '100%',
          },
          legend: {
            position: 'bottom',
            height: '100%',
            offsetY: 0,
            itemMargin: {
              vertical: 10,
              horizontal: 10,
            },
          },
        },
      },
      {
        breakpoint: 480,
        options: {
          chart: {
            width: '100%',
          },
          legend: {
            position: 'bottom',
            height: '100%',
            offsetY: 0,
            itemMargin: {
              vertical: 10,
              horizontal: 10,
            },
          },
        },
      },
      {
        breakpoint: 420,
        options: {
          chart: {
            width: 350,
          },
          legend: {
            position: 'bottom',
            height: '100%',
            offsetY: 0,
            itemMargin: {
              vertical: 10,
              horizontal: 10,
            },
          },
        },
      },
    ],
  };
};

export { Donut };
